<template>
  <div class="kehufengxiandengjiceping-jieguo">
    <div style="display:none;" @click="runAudio">隐藏播放音频按钮</div>
    <div class="top-bar">
      <div class="top-left">
        <div class="brand-mark" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></div>
        <div class="brand-name">{{ SystemName }}</div>
      </div>
      <div class="top-right">
        <svg class="shield-icon-small" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
        <span>数据安全保障</span>
      </div>
    </div>

    <div class="content" v-if="riskResult">
      <div class="success-section">
        <div class="shield-wrapper">
          <img src="@/assets/success.png" alt="测评完成" class="success-img" />
        </div>
        <h1 class="success-title">测评完成</h1>
        <p class="success-subtitle">您的风险等级评估结果如下</p>
      </div>

      <div class="result-row">
        <div class="risk-card">
          <div class="risk-left">
            <div class="risk-label">风险等级</div>
            <div class="risk-code">{{ riskResult.type }}</div>
            <div class="risk-type">{{ typenName(riskResult.type) }}</div>
            <div class="stars">
              <span v-for="i in 5" :key="i" :class="['star', { active: i <= getStarCount(riskResult.type) }]">★</span>
            </div>
          </div>
          <div class="risk-right">
            <p class="risk-desc">{{ getRiskDesc(riskResult.type) }}</p>
          </div>
        </div>

        <div class="dimension-list">
          <div class="dimension-item">
            <svg class="dim-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
            <span class="dim-name">客户期望年化收益（%）：</span>
            <span class="dim-value">{{ riskResult.customerProfile.expectedAnnualReturn }}</span>
          </div>
          <div class="dimension-item">
            <svg class="dim-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
            <span class="dim-name">客户可承受最大回撤（%）：</span>
            <span class="dim-value">{{ riskResult.customerProfile.maxAcceptableDrawdown }}</span>
          </div>
          <div class="dimension-item">
            <svg class="dim-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            <span class="dim-name">投资期限（整数年）：</span>
            <span class="dim-value">{{ riskResult.customerProfile.investmentHorizonYears }}</span>
          </div>
          <div class="dimension-item">
            <svg class="dim-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
              <line x1="16" y1="2" x2="16" y2="6" />
              <line x1="8" y1="2" x2="8" y2="6" />
              <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
            <span class="dim-name">流动性需求等级：</span>
            <span class="dim-value">{{ liquidityNeed(riskResult.customerProfile.liquidityNeed) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="btn-row">
        <button class="detail-btn" @click="handleDetail">
          查看评分详情
        </button>
        <button class="main-btn" @click="handleNext">
          进入智能投顾系统
          <svg class="arrow-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </button>
      </div>
      <div class="link-group">
        <a class="link-text" @click="handleRetry">重新测评</a>
      </div>
      <!-- <button style="min-width: 180px;
    padding: 0 28px;
    border-radius: 14px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    color: #246bff;
    background: #fff;
    border: 1px solid #bcd0ff;
    transition: all 0.3s ease;" @click="handleRetry">重新测评</button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'KehufengxiandengjicepingJieguo',
  data () {
    return {
      SystemName: window.SystemName,
      riskResult: null
    }
  },
  created () {
    this.runAudio()
    // 优先从 localStorage 获取数据（支持跨标签页共享）
    let riskResultStr = localStorage.getItem('riskResult')
    if (!riskResultStr) {
      riskResultStr = sessionStorage.getItem('riskResult')
    }

    // 如果没有数据，跳转到测评页面
    if (!riskResultStr) {
      this.$router.push({ name: 'Ceping' })
      return
    }

    this.riskResult = JSON.parse(riskResultStr)
  },
  methods: {
    runAudio () {
      this.playOnceAudio('/测评完成，您的风险等级评估如下.mp3')
    },
    typenName (type) {
      switch (type) {
        case 'C1':
          return '保守型'
        case 'C2':
          return '稳健型'
        case 'C3':
          return '平衡型'
        case 'C4':
          return '成长型'
        case 'C5':
          return '进取型'
      }
    },
    liquidityNeed (name) {
      console.log(name)
      switch (name) {
        case 'High':
          return '高'
        case 'Medium':
          return '中'
        case 'Low':
          return '低'
        default:
          return '中'
      }
    },
    getStarCount (type) {
      switch (type) {
        case 'C1':
          return 1
        case 'C2':
          return 2
        case 'C3':
          return 3
        case 'C4':
          return 4
        case 'C5':
          return 5
      }
    },
    getRiskDesc (type) {
      switch (type) {
        case 'C1':
          return '您可承受较低的风险，适合追求资产稳健增值，建议配置固定收益类资产为主的投资组合。'
        case 'C2':
          return '您可承受较低到中等的风险，适合追求稳健收益，建议配置稳健型资产为主的投资组合。'
        case 'C3':
          return '您可承受中等的风险，适合平衡收益与风险，建议配置权益类与固收类资产均衡的投资组合。'
        case 'C4':
          return '您可承受较高的风险，适合追求资产长期增值，建议配置权益类资产为主的投资组合。'
        case 'C5':
          return '您可承受高风险，适合追求高收益，建议配置高成长性权益类资产为主的投资组合。'
      }
    },
    getInvestmentHorizon (years) {
      if (years <= 1) {
        return '短期'
      } else if (years <= 3) {
        return '中期'
      } else {
        return '中长期'
      }
    },
    handleNext () {
      this.$router.push({ name: 'Aimoxingyucanshu' });
    },
    handleDetail () {
      this.$router.push({ name: 'PingfenXiangqing' });
    },
    handleRetry () {
      localStorage.removeItem('riskResult')
      sessionStorage.removeItem('riskResult')
      localStorage.removeItem('questions')
      sessionStorage.removeItem('questions')
      this.$router.push({ name: 'Ceping' });
    }
  }
}
</script>

<style scoped lang="less">
.kehufengxiandengjiceping-jieguo {
  min-height: 100vh;
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 20px 40px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  margin-bottom: 24px;
}

.brand-mark {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 36px;
}

.brand-mark i {
  display: block;
  width: 7px;
  border-radius: 8px;
  background: linear-gradient(180deg, #1768ff, #6c55ff);
  box-shadow: 0 4px 12px rgba(42, 91, 255, 0.22);
}

.brand-mark i:nth-child(1) {
  height: 18px;
}

.brand-mark i:nth-child(2) {
  height: 29px;
}

.brand-mark i:nth-child(3) {
  height: 38px;
}

.brand-mark i:nth-child(4) {
  height: 25px;
}

.brand-mark i:nth-child(5) {
  height: 12px;
}

.brand-name {
  color: #0d2148;
  font-size: 1.48rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.top-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.top-icon {
  color: #3b82f6;
}

.top-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
}

.top-right {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #64748b;
}

.shield-icon-small {
  color: #3b82f6;
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.success-section {
  text-align: center;
  margin-bottom: 10px;
}

.shield-wrapper {
  width: 360px;
  height: 120px;
  margin: 0 auto 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-img {
  width: 360px;
  height: 360px;
  object-fit: contain;
}

.success-title {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 10px 0;
}

.success-subtitle {
  font-size: 15px;
  color: #64748b;
  margin: 0;
}

.result-row {
  display: flex;
  gap: 24px;
  width: 100%;
  max-width: 960px;
  align-items: stretch;
}

.risk-card {
  background: white;
  border-radius: 20px;
  padding: 28px;
  flex: 1;
  display: flex;
  gap: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.risk-left {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 24px;
  border-right: 1px solid #e2e8f0;
}

.risk-label {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 8px;
}

.risk-code {
  font-size: 48px;
  font-weight: 700;
  color: #3b82f6;
  line-height: 1;
}

.risk-type {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-top: 4px;
}

.stars {
  display: flex;
  gap: 4px;
  margin-top: 12px;
}

.stars .star {
  font-size: 18px;
  color: #e2e8f0;
}

.stars .star.active {
  color: #fbbf24;
}

.risk-right {
  flex: 1;
  display: flex;
  align-items: center;
}

.risk-desc {
  font-size: 15px;
  color: #475569;
  line-height: 1.6;
  margin: 0;
}

.dimension-list {
  background: white;
  border-radius: 20px;
  padding: 8px 28px;
  flex: 1;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.dimension-item {
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
}

.dimension-item:last-child {
  border-bottom: none;
}

.dim-icon {
  color: #3b82f6;
  margin-right: 14px;
  flex-shrink: 0;
}

.dim-name {
  flex: 1;
  font-size: 15px;
  color: #475569;
}

.dim-value {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  margin-top: 40px;
}

.btn-row {
  display: flex;
  gap: 16px;
  width: 100%;
  max-width: 480px;
}

.main-btn {
  flex: 1;
  padding: 18px;
  font-size: 18px;
  font-weight: 600;
  color: white;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.25s ease;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.4);
  cursor: pointer;
  min-width: 0;
}

.detail-btn {
  flex: 1;
  min-width: 180px;
  padding: 0 28px;
  border-radius: 14px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  color: #246bff;
  background: #fff;
  border: 1px solid #bcd0ff;
  transition: all 0.3s ease;
}

.detail-btn:hover {
  border-color: #3b82f6;
  color: #2563eb;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.12);
}

.main-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.5);
}

.link-group {
  display: flex;
  gap: 32px;
}

.link-text {
  font-size: 14px;
  color: #64748b;
  cursor: pointer;
  transition: color 0.2s ease;
}

.link-text:hover {
  color: #3b82f6;
}

.arrow-icon {
  color: white;
}

/* 横屏：risk-card 和 dimension-list 并排一行 */
@media (min-width: 701px) and (orientation: landscape) {
  .result-row {
    flex-direction: row;
  }
}

/* 竖屏或窄屏：risk-card 和 dimension-list 上下两行 */
@media (max-width: 700px),
(orientation: portrait) {
  .result-row {
    flex-direction: column;
  }

  .risk-card {
    flex-direction: column;
    margin-bottom: 16px;
  }

  .risk-left {
    border-right: none;
    border-bottom: 1px solid #e2e8f0;
    padding-right: 0;
    padding-bottom: 20px;
  }

  .risk-right {
    padding-top: 16px;
  }
}

@media screen and (orientation: portrait) {
  .footer {
    display: none;
  }
}

@media (max-width: 600px) {
  .kehufengxiandengjiceping-jieguo {
    padding: 16px 16px;
    padding-bottom: 32px;
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
  }

  .top-bar {
    margin-bottom: 16px;
  }

  .top-title {
    font-size: 16px;
  }

  .top-right {
    font-size: 12px;
  }

  .shield-wrapper {
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
  }

  .success-img {
    width: 100px;
    height: 100px;
  }

  .success-title {
    font-size: 24px;
  }

  .success-subtitle {
    font-size: 14px;
  }

  .success-section {
    margin-bottom: 28px;
  }

  .risk-card {
    padding: 20px;
    margin-bottom: 16px;
  }

  .risk-code {
    font-size: 40px;
  }

  .risk-type {
    font-size: 16px;
  }

  .stars .star {
    font-size: 16px;
  }

  .risk-desc {
    font-size: 14px;
  }

  .dimension-list {
    padding: 8px 20px;
  }

  .dimension-item {
    padding: 14px 0;
  }

  .dim-name,
  .dim-value {
    font-size: 14px;
  }

  .footer {
    margin-top: 28px;
  }

  .main-btn {
    padding: 16px;
    font-size: 16px;
    border-radius: 10px;
  }

  .link-group {
    gap: 24px;
  }

  .link-text {
    font-size: 13px;
  }
}

@media (max-width: 400px) {
  .kehufengxiandengjiceping-jieguo {
    padding: 12px 12px;
  }

  .shield-wrapper {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
  }

  .success-img {
    width: 80px;
    height: 80px;
  }

  .success-title {
    font-size: 22px;
  }

  .success-subtitle {
    font-size: 13px;
  }

  .risk-code {
    font-size: 32px;
  }

  .risk-card {
    padding: 16px;
  }

  .dimension-list {
    padding: 6px 16px;
  }

  .dimension-item {
    padding: 12px 0;
  }

  .dim-name,
  .dim-value {
    font-size: 13px;
  }

  .main-btn {
    padding: 14px;
    font-size: 15px;
  }

  .link-group {
    gap: 20px;
  }
}
</style>
